import React, {
  useMemo,
  useState,
  useRef,
  useEffect,
  useCallback,
} from "react";
import moment from "moment-jalaali";
import { Line } from "react-chartjs-2";
import { useSelector } from "react-redux";
// import Select from "./Select/Select";
import SpinnerHandler from "../../hoc/SpinnerHandler/SpinnerHandler";
// import useHttp from '../../hooks/http';
import useAsync from "../../hooks/asyncRequests";
import Header from "../../Components/UI/Header/Header";
import Footer from "../../Components/UI/Footer/Footer";
// import Icon from '@mdi/react';
// import { mdiCloudUploadOutline } from '@mdi/js';
import Icon from "@mdi/react";
import { mdiCloudUploadOutline } from "@mdi/js";
import CInput from "../../Components/UI/CInput/CInput";
import { Helmet } from "react-helmet";
import rainfalImg from "../../assets/Charts/rainfal.png";
import tabkhirImg from "../../assets/Charts/tabkhir.png";

const watershedDic = {
  rain: "بارش",
  evp: "تبخیر",
};

const thisPageData = {
  title: "حوضه آبریز",
  options: [
    {
      value: "بارش",
      gainValue: "rain",
      unit: "mm",
      type: "rain",
      color: "130, 177, 255",
      img: rainfalImg,
    },
    {
      value: "تبخیر",
      gainValue: "evp",
      unit: "mm",
      type: "evp",
      color: "179, 229, 252",
      img: tabkhirImg,
    },
  ],
};

const Select = (props) => {
  const { list, value, setValue, Color, last } = props;
  console.log("/////////", last);

  return (
    <ul
      className="selectList"
      style={{ borderColor: value && Color ? `rgb(${Color})` : "black" }}
    >
      {list.map((item) => (
        <li
          key={item.gainValue}
          className={value === item.gainValue ? "active" : ""}
          onClick={() => setValue(item.gainValue)}
          style={{
            backgroundColor:
              value === item.gainValue && Color ? `rgba(${Color}, 0.4)` : "",
          }}
        >
          <img src={item.img} alt={item.value} />
          <div>
            <div>{item.value}</div>
            <div>
              {last && last[item.type] && last[item.type].value} ({item.unit})
            </div>
            <div>
              {last &&
                last[item.type] &&
                moment(last[item.type].date).isValid() &&
                moment(last[item.type].date).format("jYYYY/jMM/jDD")}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};

const Watershed = () => {
  const [chartData, setChartData] = useState({});
  const [value, setValue] = useState(
    thisPageData.options[thisPageData.options.length - 1].gainValue
  );
  const [last, setLast] = useState({});
  const [Range] = useState(1);

  const token = useSelector((state) => state.auth.Token);

  const { isLoadingAsync, finalData, clearAsync, Key } = useAsync({
    Key: 1,
    reqData: {
      weather: {
        url: `chart/watershed/`,
        method: "GET",
        header: { Authorization: `Bearer ${token}` },
      },
    },
  });

  const [AllChartData, setAllChartData] = useState({});
  const [Color, setColor] = useState({});
  const [Start, setStart] = useState(moment());
  const [End, setEnd] = useState(moment());
  const [isLoading, setIsLoading] = useState();

  const chartRef = useRef(null);

  useEffect(() => {
    const colors = {};
    thisPageData.options.forEach((element) => {
      colors[element.gainValue] = element.color;
    });
    setColor(colors);

    console.log(colors);
  }, [setColor]);

  useEffect(() => {
    console.log("data watershed", finalData);
    if (!finalData || !Key || Key === "loading") {
      return;
    }

    if (AllChartData[Key]) {
      return;
    }

    const { weather } = finalData;
    setLast({
      rain: weather.latest_rain,
      evp: weather.latest_evp,
    });
    const latest = {};
    const allChartData = {
      labels: { temperature: [], snow: [], rain: [], evp: [] },
    };

    const the = ["rain", "evp"];
    the.forEach((e) => {
      if (weather[e].length) {
        latest[e] = {
          ...weather["latest_" + e],
          date: moment(weather["latest_" + e].date).format("jYYYY-jMM-jDD"),
        };

        allChartData[e] = [];
        weather[e].forEach((element) => {
          const date = moment(element.date).format("jYYYY-jMM-jDD");
          allChartData.labels[e].push(date);

          allChartData[e].push({
            y: element.value,
            x: date,
          });
        });
      }
    });

    // if (weather.rain.length > 0 && weather.evp.length > 0) {
    //   const the = ['rain', 'evp'];
    //   the.forEach((e) => {
    //     latest[e] = {
    //       ...weather['latest_' + e],
    //       date: moment(weather['latest_' + e].date).format('jYYYY-jMM-jDD'),
    //     };

    //     allChartData[e] = [];
    //     weather[e].forEach((element) => {
    //       const date = moment(weather[element].date).format('jYYYY-jMM-jDD');
    //       allChartData[e].push(date);

    //       allChartData[e].push({
    //         ...weather[e][element],
    //         date: date,
    //       });
    //     });
    //   });
    // }

    console.log(allChartData);
    setAllChartData((pre) => {
      const p = { ...pre };
      p[Key] = allChartData;
      return p;
    });

    setChartData({
      data: {
        datasets: [
          {
            pointHoverRadius: 5,
            pointHitRadius: 30,
            tension: 0.4,
            fill: false,
            cubicInterpolationMode: "monotone",
            parsing: false,
          },
        ],
      },
      options: {
        animation: false,
        normalized: true,
        spanGaps: true,
        // showLine: false,
        datasets: {
          line: {
            pointRadius: 0, // disable for all `'line'` datasets
          },
        },
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          yAxes: {
            title: {
              display: true,
              // text: 'yAxisTitle',
              font: {
                size: 15,
              },
            },
          },
          xAxes: {
            x: {
              type: "time",
              time: {
                unit: "month",
              },
            },
            title: {
              display: true,
              text: "زمان",
              font: {
                size: 15,
                family: "IRANSansWeb",
                weight: "bold",
              },
            },
            ticks: {
              maxTicksLimit: 12,
            },
          },
        },
      },
    });

    clearAsync();
  }, [finalData, setAllChartData, setChartData, clearAsync, AllChartData, Key]);

  useEffect(() => console.log(AllChartData), [AllChartData]);
  useEffect(() => console.log(Key), [Key]);

  // const download = useCallback(() => {
  //   fetch(chartRef.current.toBase64Image(), {
  //     method: 'GET',
  //     headers: {},
  //   })
  //     .then((response) => {
  //       response.arrayBuffer().then(function (buffer) {
  //         const url = window.URL.createObjectURL(new Blob([buffer]));
  //         const link = document.createElement('a');
  //         link.href = url;
  //         link.setAttribute('download', `${value}.png`);
  //         document.body.appendChild(link);
  //         link.click();
  //       });
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, [chartRef, value]);

  const chart = useMemo(() => {
    if (chartData) {
      let dt = null;
      if (chartData.data && chartData.data.datasets[0].data) {
        dt = chartData;
      }

      return  dt &&<Line ref={chartRef} {...dt} />;
    }
  }, [chartData, chartRef]);

  useEffect(() => {
    if (value) {
      const thisValue = thisPageData.options.find((e) => e.gainValue === value);
      setChartData(
        (pre) =>
          pre &&
          Object.keys(pre).length && {
            ...pre,
            data: {
              labels: AllChartData[Range].labels[thisValue.type],
              datasets: [
                {
                  ...pre.data.datasets[0],
                  label: value,
                  data: AllChartData[Range][value],
                  // backgroundColor: `rgba(${Color[value]}, 0.4)`,
                  backgroundColor: `rgb(${Color[value]})`,
                  borderColor: `rgb(${Color[value]})`,
                },
              ],
            },
            options: {
              ...pre.options,
              scales: {
                ...pre.options.scales,
                yAxes: {
                  title: {
                    ...pre.options.scales.yAxes.title,
                    text: watershedDic[value],
                    font: {
                      size: 15,
                      family: "IRANSansWeb",
                      weight: "bold",
                    },
                  },
                },
              },
            },
          }
      );
    }
  }, [value, setChartData, AllChartData, Color, Range]);

  const downloadCSV = useCallback(() => {
    if (Start.format("YYYY-MM-DD") === End.format("YYYY-MM-DD")) {
      return;
    }
    setIsLoading(true);
    fetch(
      `http://213.233.177.17:8022/download/watershed_detail?watershed_id=1&start_date=${Start.format(
        "YYYY-MM-DD"
      )}&end_date=${End.format("YYYY-MM-DD")}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => {
        return response.blob().then((data) => {
          const the = response.headers.get("Content-disposition");
          const thea = the.slice(the.indexOf('"') + 1, the.length - 1);
          console.log(the);
          console.log(thea);

          return {
            blob: data,
            fileName: thea,
          };
        });
      })
      .then(({ blob, fileName }) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = (fileName ? fileName : "matter") + ".csv";
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove(); //afterwards we remove the element again)
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  }, [token, Start, End]);

  const downloadUI = useMemo(() => {
    return (
      <div className="chartDownload">
        <CInput
          config={{
            type: "calendar",
            placeholder: "تاریخ شروع",
          }}
          value={Start}
          direction="rtl"
          changed={setStart}
        />
        <CInput
          config={{
            type: "calendar",
            placeholder: "تاریخ پایان",
          }}
          value={End}
          direction="rtl"
          changed={setEnd}
        />
        <button onClick={() => downloadCSV()}>
          دریافت داده ها به فرمت CSV{" "}
          <Icon path={mdiCloudUploadOutline} size={1} />
        </button>
      </div>
    );
  }, [downloadCSV, Start, End, setStart, setEnd]);

  return (
    <SpinnerHandler isLoading={isLoadingAsync || isLoading}>
      <Helmet>
        <title>نمودار حوضه آبریز</title>
      </Helmet>
      <Header />
      <div className="chartInfo">
        <h2>{thisPageData.title}</h2>

        {thisPageData.options && (
          <Select
            value={value}
            setValue={setValue}
            list={thisPageData.options}
            Color={Color[value]}
            last={last}
          ></Select>
        )}
      </div>

      <div className="center damChart">
        <div />
        <div>{chart}</div>
      </div>

      {downloadUI}
      <Footer />
    </SpinnerHandler>
  );
};

export default Watershed;
